//修改新设备保存列表
export const DEVICEMANAGEMENT_UPDATE_DEVICE='DEVICEMANAGEMENT/DEVICE/LIST/DEVICEMANAGEMENT_UPDATE_DEVICE';
